import { Link } from 'react-router-dom';


const ShoppingCartIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </svg>
);


const PricingCard = ({ title, originalPrice, offerPrice, type, highlight }) => {
  // A mapping of plan types to their feature lists.
  const features = {
    unit: ['Single Unit Notes', 'PDF Format', 'Instant Access', 'Priority Support'],
    subject: ['All 5 Units', 'PYQs Included', 'Instant Access', 'Priority Support'],
    semester: ['All Subjects Notes', 'Priority Support', 'Full Semester Coverage'],
  };

  // Use the 'type' prop to get the correct features, with a fallback to 'subject'.
  const cardFeatures = features[type] || features.subject;


  return (
    <div className={`relative group rounded-2xl w-full h-full ${highlight ? 'p-px bg-gradient-to-br from-indigo-500 to-purple-500' : 'bg-slate-800 border border-slate-700'}`}>
      <div className="relative bg-slate-900 rounded-2xl p-6 h-full flex flex-col">
        {/* Highlight effect for popular card */}
        {highlight && (
          <div className="absolute -top-px -left-px -right-px h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-t-2xl filter blur-xl opacity-30 group-hover:opacity-50 transition-opacity"></div>
        )}
        {/* "Popular" banner for highlighted card */}
        {highlight && (
          <div className="absolute top-0 right-0 overflow-hidden w-24 h-24">
            <div className="absolute transform rotate-45 bg-indigo-500 text-center text-white font-semibold py-1 -right-8 top-8 w-32">Popular</div>
          </div>
        )}
        
        <div className="flex-grow">
          <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
          <p className="text-slate-400 text-sm mb-4">Ideal for {title} purchase.</p>

          <div className="my-6">
            <span className="text-5xl font-extrabold text-white">₹{offerPrice}</span>
            <span className="text-xl font-medium text-slate-500 line-through ml-2">₹{originalPrice}</span>
          </div>

          <ul className="space-y-3 text-slate-400 text-sm">
            {cardFeatures.map(feature => (
              <li key={feature} className="flex items-center gap-2">
                <svg className="w-4 h-4 text-green-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        <Link to="search">
        <button 
          className={`mt-8 w-full font-semibold py-3 px-4 rounded-lg transition-all flex items-center justify-center gap-2 group ${highlight ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:shadow-lg hover:shadow-indigo-500/30' : 'bg-slate-700 text-slate-200 hover:bg-slate-600'}`}
        >
          <ShoppingCartIcon />
          <span>Buy Now</span>
        </button>
        </Link>
      </div>
    </div>
  );
};

// Example of how to use the PricingCard in a parent component
export default function App() {
  const pricingData = [
    { title: 'Unit Notes', originalPrice: 15, offerPrice: 7, type: 'unit' },
    { title: 'Subject Notes', originalPrice: 39, offerPrice: 19, type: 'subject' },
    { title: 'Semester Notes', originalPrice: 149, offerPrice: 79, type: 'semester', highlight: true },
  ];

  return (
    <div className=" p-4 sm:p-8 flex items-center justify-center">
      <div className="w-full max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pricingData.map((data) => (
            <PricingCard key={data.title} {...data} />
          ))}
        </div>
      </div>
    </div>
  );
}
